import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { checkIfDirectBoss } from "../../services/direct-boss.service.ts";
import { setIsDirectBoss } from "../../store/slices/directBossSlice.ts";

const DirectBossStatusProvider: React.FC = () => {
  const dispatch = useDispatch();
  const { partner } = useSelector((s: RootState) => s.auth);
  const lastCheckedPartnerIdRef = React.useRef<number | null>(null);

  React.useEffect(() => {
    const run = async () => {
      if (!partner?.id) return;
      if (lastCheckedPartnerIdRef.current === partner.id) return;
      try {
        const result = await checkIfDirectBoss(partner.id);
        dispatch(setIsDirectBoss({ isDirectBoss: result.isDirectBoss, bossId: partner.id }));
        lastCheckedPartnerIdRef.current = partner.id;
      } catch (e) {
        dispatch(setIsDirectBoss({ isDirectBoss: false, bossId: null }));
      }
    };
    run();
  }, [partner?.id, dispatch]);

  return null;
};

export default DirectBossStatusProvider;


